/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {

  addBanks: (data) => {
    return axios.post(API_ENDPOINTS.ADD_Banks, data, {
      headers:{ isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  getbanksList: (params) => {
    return axios.get(API_ENDPOINTS.GET_BANKS_LIST, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getBankDetailsbyId: (id) => {
    return axios.get(API_ENDPOINTS.GET_BANK_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  updateBank: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_BANK_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers:  { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
 deleteBank: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_BANK_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },

    addBanksacc: (data) => {
    return axios.post(API_ENDPOINTS.ADD_Banks_ACC, data, {
      headers:{ isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  getbanksListacc: (params) => {
    return axios.get(API_ENDPOINTS.GET_BANKS_LIST_ACC, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
      params,
    });
  },
  getBankDetailsbyIdacc: (id) => {
    return axios.get(API_ENDPOINTS.GET_BANK_DETAILS_BY_ID_ACC + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  updateBankacc: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_BANK_DETAILS_BY_ID_ACC + "/" + id;
    return axios.put(url, data, {
      headers:  { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
 deleteBankacc: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_BANK_DETAILS_BY_ID_ACC + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
};
